import { Component, ViewChild, OnInit } from '@angular/core';
import * as moment from 'moment';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TrainingClass } from '../../models/domain/training.class';
import { AdminItem } from '../../models/domain/admin.item';
import { UpdateTrainingClassRequest } from '../../models/ss-api/requests/update.training.class.request';
import { TrainingClassTrainerSurveyURLArray, TrainingClassTrainerSurveyURL } from '../../models/domain/training.class.trainer.surveyurl';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { CKEditorComponent } from 'ng2-ckeditor';
import { EmailTemplateBasicsItem } from '../../../app/models/domain/email.template.basics.item';
import { TemplateTypes } from '../../../app/models/domain/email.template.item';
import { Router } from '@angular/router';
import { VersionItemArray } from '@models/domain/version.item';

class Trainer {
    trainer: AdminItem;
    url: string;
    embedhtml: string;
}

class ProductModel {
    label: string;
    value: number;
    Products: any[];
}

export interface IEditClassDialogModel {
    title: string;
    class: TrainingClass;
    productOptions: ProductModel[];
}

@Component({
    selector: 'edit-class-dialog',
    styleUrls: ['./edit.class.dialog.css'],
    templateUrl: './edit.class.dialog.html'
})

export class EditClassDialog extends DialogComponent<IEditClassDialogModel, boolean> implements IEditClassDialogModel, OnInit {
    IsBusy: boolean = true;
    title: string;
    class: TrainingClass = new TrainingClass();
    productOptions: ProductModel[];
    ClassForm: FormGroup;
    Products: any[] = new Array<any>();
    Trainers: Array<Trainer> = new Array<Trainer>();
    TrainingEmailTemplates: Array<EmailTemplateBasicsItem>;
    SoftwareVersions: VersionItemArray;

    @ViewChild('CKEDITORDESCRIPTION') CKEDITORDESCRIPTION: CKEditorComponent;
    @ViewChild('CKEDITOREXPLANATION') CKEDITOREXPLANATION: CKEditorComponent;
    @ViewChild('CKEDITORFOLLOWUP') CKEDITORFOLLOWUP: CKEditorComponent;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
        this.loadProducts();
    }

    ngOnInit() {
        this.getTrainers();
        this.getTemplates();
        this.InitVersions();

        console.log("tclas", this.class);

        this.ClassForm = new FormGroup({
            'name': new FormControl(this.class.ClassName, [Validators.required, Validators.minLength(5)]),
            'title': new FormControl(this.class.ClassTitle, [Validators.required, Validators.minLength(5)]),
            'preview': new FormControl(this.class.PreviewText, [Validators.required, Validators.minLength(10)]),
            'hours': new FormControl(moment(this.class.ClassDuration, 'hh:mm:ss').toDate(), [Validators.required]),
            'credits': new FormControl(this.class.ClassCredits, [Validators.required]),
            'level': new FormControl(this.class.LevelOrder, [Validators.required]),
            'trainer': new FormControl(this.class.TrainerID, [Validators.required]),
            'explanation': new FormControl(this.class.Explanation, [Validators.required]),
            'introductoryVideoLabel': new FormControl(this.class.IntroductoryVideoLabel, [Validators.required]),
            'introductoryVideoURL': new FormControl(this.class.IntroductoryVideoURL, [Validators.required]),
            'dimensionsGuideLabel': new FormControl(this.class.DimensionsGuideLabel, [Validators.required]),
            'dimensionsGuideURL': new FormControl(this.class.DimensionsGuideURL, [Validators.required]),
            'followupSteps': new FormControl(this.class.FollowupSteps, [Validators.required]),
            'fundamentals': new FormControl(this.class.FundamentalsClass, [Validators.required]),
            'trainingDesignURL': new FormControl(this.class.TrainingDesignURL, [Validators.required]),
            'setupEmailTemplate': new FormControl(this.class.EmailTemplateSetup),
            'reminderEmailTemplate': new FormControl(this.class.EmailTemplateReminder),
            'noShowEmailTemplate': new FormControl(this.class.EmailTemplateNoShows),
            'selfCancelEmailTemplate': new FormControl(this.class.EmailTemplateSelfCancel),
            'confirmationEmailTemplate': new FormControl(this.class.EmailTemplateRegistrationConfirmation),
            'certificateEmailTemplate': new FormControl(this.class.EmailTemplateCertificate),
            'description': new FormControl(this.class.ClassDescription, [Validators.required, Validators.minLength(5)]),
            'MinimumSoftwareVersionInt': new FormControl(this.class.MinimumSoftwareVersionInt),
            'MaximumSoftwareVersionInt': new FormControl(this.class.MaximumSoftwareVersionInt),
            'OrderFormVisible': new FormControl(this.class.OrderFormVisible),
            'OrderFormDisplayName': new FormControl(this.class.OrderFormDisplayName),
            'OrderFormValue': new FormControl(this.class.OrderFormValue),
            'OrderFormPrice': new FormControl(this.class.OrderFormPrice)            
        });
    }

    InitVersions() {
        let disposable = this.api.GetActiveV3Versions().subscribe(response => {
            if (response.Result) {
                
                var softwareVersions = response.Data;

                var appropriateVersions = new VersionItemArray();
                softwareVersions.forEach((version) => {
                    if (version.VersionInt >= 2024100){
                        appropriateVersions.push(version);
                    }
                });                        

                this.SoftwareVersions = appropriateVersions;
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Versions',
                    text: response.Message
                }).then(() => { }, () => { });
            }

            disposable.unsubscribe();
        });
        
    }     


    loadProducts() {
        this.gb.GetStructureStudiosProductsBasics().then(data => {
            console.log("classproducts", data);
            data.filter(p => p.ModuleType == 'PoolStudio' || p.ModuleType == 'VIPD3D' || p.ModuleType == 'VizTerra').forEach(function (product) {
                if (product.ID < 4) {
                    let icon = '';
                    let color = '';
                    switch (product.ID) {
                        case 3:
                            icon = '../../assets/images/icons/logo-icons-vip3d-xs.png';
                            color = '#0064DF';
                            break;
                        case 2:
                            icon = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
                            color = '#FF0000';
                            break;
                        case 1:
                            icon = '../../assets/images/icons/logo-icons-vizterra-xs.png';
                            color = '#64A000';
                            break;
                    }
                    this.Products.push({
                        label: product.Name,
                        value: product.ID,
                        image: icon,
                        color: color,
                        active: this.getProductStatus(product.ID)
                    });
                }
            }, this);
        });
    }

    private getTrainers() {
        let disposable = this.api.GetTrainers().subscribe(response => {
            response.Data.forEach(function (trainer) {
                let t: Trainer = {
                    trainer: trainer,
                    url: this.getUrlForTrainer(trainer),
                    embedhtml: this.getHTMLForTrainer(trainer)
                };
                this.Trainers.push(t);
            }, this);
            disposable.unsubscribe();
            this.IsBusy = false;
        });
    }

    private getTemplates() {

        let disposable = this.api.GetEmailTemplatesBasicsAndFrom().subscribe(response => {
            if (response.Result) {
                this.TrainingEmailTemplates = response.Data.Templates.filter(template => template.TemplateType == TemplateTypes.Training);
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error Loading Templates',
                    text: response.Message
                }).then(() => { }, () => { });
            }

            disposable.unsubscribe();
        });
    }

    getUrlForTrainer(trainer: AdminItem): string {
        let string = '';
        this.class.TrainingClassTrainerSurveyURLs.forEach(function (url) {
            if (url.TrainerID == trainer.AdminID) {
                string = url.SurveyURL;
            }
        });
        return string;
    }

    getHTMLForTrainer(trainer: AdminItem): string {
        console.log("ght", this.class.TrainingClassTrainerSurveyURLs);
        let string = '';
        this.class.TrainingClassTrainerSurveyURLs.forEach(function (url) {
            if (url.TrainerID == trainer.AdminID) {
                string = url.EmbeddedSurveyHTML;
            }
        });
        return string;
    }

    getProductStatus(id: number): Boolean {
        if (this.class.ProductIDs.indexOf(id) >= 0) {
            return true;
        } else {
            return false;
        }
    }

    onProductClick(product) {
        product.active = !product.active;
    }

    // CKEditor Config
    private CKEditorBigConfig = {
        height: '550px'
    }

    confirm() {
        let request: UpdateTrainingClassRequest = new UpdateTrainingClassRequest();
        let surveyURLs: TrainingClassTrainerSurveyURLArray = new TrainingClassTrainerSurveyURLArray();
        let fields = this.ClassForm.controls;
        this.class.ProductIDs = [];
        this.IsBusy = true;

        if (this.CKEDITORDESCRIPTION.instance['mode'] != 'wysiwyg') {

            this.CKEDITORDESCRIPTION.instance['commands']['source'].exec();
            setTimeout(() => {
                this.confirm();
            }, 500);

            return false;

        }

        if (this.CKEDITOREXPLANATION.instance['mode'] != 'wysiwyg') {

            this.CKEDITOREXPLANATION.instance['commands']['source'].exec();
            setTimeout(() => {
                this.confirm();
            }, 500);

            return false;

        }

        if (this.CKEDITORFOLLOWUP.instance['mode'] != 'wysiwyg') {

            this.CKEDITORFOLLOWUP.instance['commands']['source'].exec();
            setTimeout(() => {
                this.confirm();
            }, 500);

            return false;

        }

        this.Products.forEach(function (product) {
            if (product.active) {
                this.class.ProductIDs.push(product.value);
            }
        }, this);

        // Proof of concept form validation w/ swal errors
        if (!this.class.ProductIDs || this.class.ProductIDs.length == 0) {
            this.showError('Please select a product');
            return false;
        } else {
            request.ProductIDs = this.class.ProductIDs;
        }

        request.APSPCertificate = false;

        if (fields.fundamentals.valid) {
            request.FundamentalsClass = fields.fundamentals.value;
        } else {
            this.showError('Please define whether this class is Fundamentals or not.');
            return false;
        }

        if (fields.OrderFormPrice.valid){
            request.OrderFormPrice = fields.OrderFormPrice.value;
        }
        else{
            this.showError('Order Form Price must be 0 or a valid amount.');
            return false;
        }

        if (fields.OrderFormValue.valid){
            request.OrderFormValue = fields.OrderFormValue.value;
        }
        else{
            this.showError('Order Form Value must be 0 or a valid amount.');
            return false;
        }

        if (fields.credits.valid) {
            request.ClassCredits = fields.credits.value;
        } else {
            this.showError('Please define the credits rewarded by this class');
            return false;
        }

        if (fields.description.valid) {
            request.ClassDescription = fields.description.value;
        } else {
            this.showError('Please add a class description.');
            return false;
        }

        if (fields.hours.valid) {
            request.ClassDuration = moment(fields.hours.value).format('hh:mm:ss');
        } else {
            this.showError('Please add a duration to the class');
            return false;
        }

        if (fields.name.valid) {
            request.ClassName = fields.name.value;
        } else {
            this.showError('Please add a name to the class!');
            return false;
        }

        if (fields.title.valid) {
            request.ClassTitle = fields.title.value;
        } else {
            this.showError('Please add a title to the class');
            return false;
        }

        if (fields.preview.valid) {
            request.PreviewText = fields.preview.value;
        } else {
            this.showError('Please add Preview Text to the class');
            return false;
        }

        request.DimensionsGuideLabel = fields.dimensionsGuideLabel.value;
        request.DimensionsGuideURL = fields.dimensionsGuideURL.value;
        request.Explanation = fields.explanation.value;
        request.FollowupSteps = fields.followupSteps.value;
        request.IntroductoryVideoLabel = fields.introductoryVideoLabel.value;
        request.IntroductoryVideoURL = fields.introductoryVideoURL.value;
        request.LevelOrder = fields.level.value;
        request.TrainerID = fields.trainer.value;
        request.ClassID = this.class.ID;
        request.TrainingDesignURL = fields.trainingDesignURL.value;

        request.EmailTemplateCertificate = fields.certificateEmailTemplate.value;
        request.EmailTemplateNoShows = fields.noShowEmailTemplate.value;
        request.EmailTemplateRegistrationConfirmation = fields.confirmationEmailTemplate.value;
        request.EmailTemplateReminder = fields.reminderEmailTemplate.value;
        request.EmailTemplateSelfCancel = fields.selfCancelEmailTemplate.value;
        request.EmailTemplateSetup = fields.setupEmailTemplate.value;

        request.OrderFormDisplayName = fields.OrderFormDisplayName.value;
        request.OrderFormVisible = fields.OrderFormVisible.value;         

        this.Trainers.forEach(function (trainer) {
            let survey: TrainingClassTrainerSurveyURL = new TrainingClassTrainerSurveyURL();
            survey.TrainerID = trainer.trainer.AdminID;
            survey.SurveyURL = trainer.url;
            survey.EmbeddedSurveyHTML = trainer.embedhtml;

            surveyURLs.push(survey);
        });

        request.MinimumSoftwareVersionInt = fields.MinimumSoftwareVersionInt.value;
        request.MaximumSoftwareVersionInt = fields.MaximumSoftwareVersionInt.value;

        request.TrainingClassTrainerSurveyURLs = surveyURLs;

        console.log("tcupd", request);

        let disposable = this.api.UpdateTrainingClass(request).subscribe(response => {
            this.IsBusy = false;
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Event Saved',
                    text: 'Event saved successfully',
                    timer: 1500
                }).then(() => { });
                this.result = true;
                this.close();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Event Not Saved',
                    text: response.Message
                }).then(() => { });
            }
            disposable.unsubscribe();
        });
    }

    showError(error) {
        this.sweetAlert.swal({
            title: 'Whoops!',
            text: error,
            type: 'error'
        });
        this.IsBusy = false;
    }

    DeleteClass() {
        this.sweetAlert.swal({
            title: 'Are you sure?',
            text: 'This will delete the class and all events using this class will be lost.',
            type: 'warning',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.DeleteTrainingClass(this.class.ID).toPromise();
            }
        }).then(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    title: 'Success',
                    text: 'Class Deleted',
                    type: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 1500
                }).then((response: any) => {

                }, () => { }); // keep this line to prevent promise error;
                this.result = true;
                this.close();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Event Not Deleted',
                    text: response.Message
                }).then(() => { });
            }
        }, (dismiss) => {

        });

    }

}
